import { createAction } from 'redux-actions';

export const clearReservationView = createAction('CLEAR_RESERVATION_VIEW');
